import { Link } from 'react-router-dom';
import { useAuth, EMULATABLE_ROLES } from '../hooks/useAuth.js';

export default function MorePage() {
  const { isAdmin, isRealAdmin, viewAs, setViewAs, logout } = useAuth();

  return (
    <div className="panel">
      <h3 className="panel-title">
        <span><i className="ph ph-dots-three-circle" /> More</span>
      </h3>
      <ul className="more-list">
        <li><Link to="/profile"><i className="ph ph-user-circle" /> Profile</Link></li>
        <li><Link to="/schedule"><i className="ph ph-calendar" /> Schedule</Link></li>
        <li><Link to="/expenses"><i className="ph ph-receipt" /> Expenses</Link></li>
        <li><Link to="/wiki"><i className="ph ph-book-open" /> Wiki</Link></li>
        {isAdmin && (
          <>
            <li><Link to="/admin/dashboard"><i className="ph ph-gauge" /> Admin dashboard</Link></li>
            <li><Link to="/admin/pay"><i className="ph ph-money" /> Pay runs</Link></li>
            <li><Link to="/admin/expenses"><i className="ph ph-receipt" /> Expense queue</Link></li>
            <li><Link to="/admin/jobs"><i className="ph ph-map-pin" /> Jobs</Link></li>
            <li><Link to="/admin/crew"><i className="ph ph-users-three" /> Crew</Link></li>
            <li><Link to="/admin/reports"><i className="ph ph-chart-bar" /> Reports</Link></li>
            <li><Link to="/admin/jha"><i className="ph ph-shield-check" /> JHA template</Link></li>
            <li><Link to="/admin/documents"><i className="ph ph-file-text" /> All documents</Link></li>
            <li><Link to="/admin/settings"><i className="ph ph-gear" /> Settings</Link></li>
            <li><Link to="/admin/sessions"><i className="ph ph-devices" /> Sessions</Link></li>
            <li><Link to="/admin/audit"><i className="ph ph-list-magnifying-glass" /> Audit log</Link></li>
          </>
        )}
        {isRealAdmin && (
          <li style={{ borderTop: '1px solid var(--surface-container)', paddingTop: 12, marginTop: 8 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <div style={{ fontFamily: 'var(--font-label)', fontSize: 11, letterSpacing: '0.08rem', textTransform: 'uppercase', color: 'var(--warm-gray)' }}>
                Preview as
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                <button
                  className={'btn-sm' + (!viewAs ? ' primary' : '')}
                  onClick={() => setViewAs(null)}
                >
                  admin (real)
                </button>
                {EMULATABLE_ROLES.map(r => (
                  <button
                    key={r}
                    className={'btn-sm' + (viewAs === r ? ' primary' : '')}
                    onClick={() => setViewAs(r)}
                  >
                    {r}
                  </button>
                ))}
              </div>
            </div>
          </li>
        )}
        <li>
          <button className="more-list-button" onClick={logout}>
            <i className="ph ph-sign-out" /> Sign out
          </button>
        </li>
      </ul>
    </div>
  );
}
